module.exports = __webpack_public_path__ + "2e7e2ddca3508f9b9b769583c2d62f6e.svg";